import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46a3fdc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "courses d-flex flex-column" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-center mt-3 pb-4 mb-2" }, "Verfügbare Kurse", -1))
const _hoisted_3 = {
  key: 0,
  class: "row mt-4 text-center"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "heading" }, "Kurse", -1))
const _hoisted_5 = { class: "courses-container d-flex flex-wrap justify-content-center align-content-between" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "card-highlight"
}
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "card-title" }
const _hoisted_10 = { class: "card-description" }
const _hoisted_11 = { class: "card-btn" }
const _hoisted_12 = {
  key: 0,
  class: "success"
}
const _hoisted_13 = { class: "btn-secondary" }
const _hoisted_14 = {
  key: 1,
  class: "row mt-4 text-center"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted" }, "Es sind noch keine Kurse für Sie freigeschaltet.", -1))
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_banner = _resolveComponent("banner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_banner, {
      points: _ctx.points(),
      image: "banner-img.png",
      class: "mb-4"
    }, null, 8, ["points"]),
    (_ctx.lmsModules.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lmsModules, (m) => {
              return (_openBlock(), _createElementBlock("div", {
                key: m.id,
                class: "mx-4 mb-5",
                onClick: ($event: any) => (_ctx.$router.push({ name: 'lmsModule', params: { moduleId: m.id } }))
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["card", { 'card--done': _ctx.lmsIsCompleted(m.id) }])
                }, [
                  (_ctx.lmsIsCompleted(m.id))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: _normalizeClass(["card-img", m.image ? 'card-img--photo' : 'card-img--placeholder'])
                  }, [
                    (m.image)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: m.image,
                          alt: m.title,
                          class: "card-photo"
                        }, null, 8, _hoisted_8))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(m.title), 1),
                  _createElementVNode("div", _hoisted_10, _toDisplayString(m.description.substring(0, 120)) + _toDisplayString(m.description.length > 120 ? '…' : ''), 1),
                  _createElementVNode("div", _hoisted_11, [
                    (_ctx.lmsIsCompleted(m.id))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Abgeschlossen"))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_13, "⏱ " + _toDisplayString(m.duration_minutes) + " Min.", 1)
                  ])
                ], 2)
              ], 8, _hoisted_6))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.lmsModules.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
      : _createCommentVNode("", true)
  ]))
}